import {type CompanySuggestionsResource, Configuration, SuggestCompaniesApi} from '@api';
import {CompanySuggestion} from '~/types/domain/CompanySuggestions';

export default class CompanySuggestCompaniesApiSearcher {
    private api = new SuggestCompaniesApi(new Configuration({basePath: ''}));

    async search(query: string): Promise<CompanySuggestion[]> {
        const companySuggestions = await this.api.suggestCompany({q: encodeURIComponent(query)});

        const companySuggestionFromQuery = new CompanySuggestion({text: query, key: '', others: {}});
        if (this.suggestionsDoesNotContainQuery(companySuggestions, query)) {
            return Promise.resolve([companySuggestionFromQuery, ...(companySuggestions.suggestions as CompanySuggestion[])]);
        }

        return Promise.resolve(companySuggestions.suggestions as CompanySuggestion[]);
    }

    private suggestionsDoesNotContainQuery(companySuggestions: CompanySuggestionsResource, query: string) {
        return !companySuggestions.suggestions.some((company) => company.text.toLowerCase() === query.toLowerCase());
    }
}
